// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_BFD","cls2":"ActiveState-cls2_cW0 ActiveState-cls1_BFD"};